import React, { useEffect, useState } from 'react';

const API_URL = "https://api.garturbo.com"; 

const BannerManagement = () => {
  const [existingBanners, setExistingBanners] = useState([]);
  const [newBanners, setNewBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      const res = await fetch(`${API_URL}/banner/fetchBanner`);
      const data = await res.json();
      setExistingBanners(data.data?.banners || []);
    };
    fetchBanners();
  }, []);

  const handleFileChange = (e) => {
    setNewBanners([...newBanners, ...Array.from(e.target.files)]);
  };

  const handleRemove = async (img) => {
    const filename = img.split('/').pop();
    const token = localStorage.getItem('adminToken');

    const res = await fetch(`${API_URL}/banner/deleteBanner`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token,
      },
      body: JSON.stringify({ filenames: [filename] }),
    });

    const result = await res.json();
    if (result.status === 'success') {
      setExistingBanners(existingBanners.filter((i) => i !== img));
    } else {
      alert('删除失败');
    }
  };

  const handleRemoveNew = (index) => {
    setNewBanners(newBanners.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    const formData = new FormData();
    newBanners.forEach(file => formData.append('banners', file));

    const token = localStorage.getItem('adminToken');

    const res = await fetch(`${API_URL}/banner/updateBanner`, {
      method: 'POST',
      headers: {
        token,
      },
      body: formData,
    });

    const result = await res.json();
    if (result.status === 'success') {
      alert('上传成功');
      setNewBanners([]);
      setExistingBanners([...existingBanners, ...result.data.banners]);
    } else {
      alert('上传失败');
    }
  };

  return (
    <div style={{ padding: '30px', fontFamily: 'sans-serif' }}>

      {/* Existing banners */}
      <section style={{ marginBottom: '30px' }}>
        <h3 style={{ marginBottom: '10px' }}>🖼️ 当前横幅</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
          {existingBanners.map((img, i) => (
            <div
              key={i}
              style={{
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '10px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
              }}
            >
              <img
                src={`${API_URL}${img}`}
                alt="banner"
                style={{ width: '200px', borderRadius: '4px' }}
              />
              <button
                onClick={() => handleRemove(img)}
                style={{
                  marginTop: '8px',
                  padding: '6px 12px',
                  backgroundColor: '#ff4d4f',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                删除
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* New banner upload */}
      <section style={{ marginBottom: '30px' }}>
        <h3 style={{ marginBottom: '10px' }}>📤 上传新横幅</h3>
        <input type="file" multiple onChange={handleFileChange} />
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '10px' }}>
          {newBanners.map((file, i) => (
            <div
              key={i}
              style={{
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '10px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
              }}
            >
              <img
                src={URL.createObjectURL(file)}
                alt="new-banner"
                style={{ width: '200px', borderRadius: '4px' }}
              />
              <button
                onClick={() => handleRemoveNew(i)}
                style={{
                  marginTop: '8px',
                  padding: '6px 12px',
                  backgroundColor: '#faad14',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                移除
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Save button */}
      <div style={{ textAlign: 'center' }}>
        <button
          onClick={handleSave}
          style={{
            padding: '12px 24px',
            backgroundColor: '#1890ff',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '16px',
            cursor: 'pointer',
          }}
        >
          💾 保存上传
        </button>
      </div>
    </div>
  );
};

export default BannerManagement;
